import {
  DataTypeProvider,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import Paper from '@material-ui/core/Paper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';

import { dateFormatter } from '../../utilities/dateFormatter';
import FullscreenSpinner from 'common/fullscreenSpinner.component';

const ConfidentialTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={(params) => {
      return params.row.isConfidentialFile ? <FontAwesomeIcon icon="check" /> : "";
    }}
    {...props}
  />
);

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={dateFormatter} {...props} />
);

const getRowId = (row) => row.AuthorizationID;

class SubmittedAuthorizations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'isConfidentialFile', title: 'Confidential' },
        { name: 'firstName', title: 'First Name' },
        { name: 'lastName', title: 'Last Name' },
        { name: 'destinationCity', title: 'Dest. City' },
        { name: 'destinationCountryId', title: 'Dest. Country', getCellValue: (row) => (
          <div>
              {this.props.countryEnums ? this.props.countryEnums.find((ce) => ce.id === row.destinationCountryId)?.title : row.destinationCountryId}
          </div> 
        ) },
        { name: 'submittedOn', title: 'Submitted' },
      ],
      rows: [],
      currentPage: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15],
      dateColumns: ['submittedOn'],
      confidentialColumns: ['isConfidentialFile'],
      tableColumnExtensions: [{ columnName: "isConfidentialFile", width: 150 }],
      sorting: [{ columnName: 'submittedOn', direction: 'desc' }],
    };

    this.changeSorting = (sorting) => this.setState({ sorting });
    this.changeCurrentPage = (currentPage) => this.setState({ currentPage });
    this.changePageSize = (pageSize) => this.setState({ pageSize });
  }

  TableRow = ({ row, ...restProps }) => {
    return (
      <Table.Row
        {...restProps}
        onClick={() => this.props.handleViewAuthorization(row.tempFileId)}
        style={{
          cursor: 'pointer',
        }}
      />
    );
  };

  render() {
    const { columns, pageSize, pageSizes, currentPage, dateColumns, sorting, confidentialColumns } =
      this.state;
    const { rows, isLoading, hasConfidentialFileAccess } = this.props;

    const flattenedRows = rows.map((row) => row.tempFile);

    return (
      <div>
        <Paper style={{ padding: '0.5rem' }}>
          <div style={{ padding: '0.3rem', fontSize: '1.25rem' }}>
            Submitted Authorizations
          </div>
          {isLoading ? (
            <FullscreenSpinner />
          ) : (
            <Grid rows={flattenedRows} columns={hasConfidentialFileAccess ? columns : columns.filter((column) => column.name !== "isConfidentialFile")} getRowId={getRowId}>
              <DateTypeProvider for={dateColumns} />
              <ConfidentialTypeProvider for={confidentialColumns} />
              <SortingState
                sorting={sorting}
                onSortingChange={this.changeSorting}
              />
              <PagingState
                currentPage={currentPage}
                onCurrentPageChange={this.changeCurrentPage}
                pageSize={pageSize}
                onPageSizeChange={this.changePageSize}
              />
              <IntegratedSorting />
              <IntegratedPaging />
              <Table rowComponent={this.TableRow} columnExtensions={this.state.tableColumnExtensions} />
              <TableHeaderRow showSortingControls />
              {flattenedRows && flattenedRows.length > 5 && <PagingPanel pageSizes={pageSizes} />}
            </Grid>
          )}
        </Paper>
      </div>
    );
  }
}

export default SubmittedAuthorizations;
